// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-icon-style {
    position: relative;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    outline: 0px;
    margin: 0px;
    cursor: pointer;
    vertical-align: middle;
    appearance: none;
    text-decoration: none;
    font-family: Roboto, Helvetica, Arial, sans-serif;
    letter-spacing: 0.02857em;
    /*border: 1px solid rgb(130, 214, 22);*/
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    line-height: 1.4;
    text-align: center;
    text-transform: uppercase;
    -webkit-user-select: none;
            user-select: none;
    transition: 150ms ease-in;
    font-size: 0.75rem;
    background-image: initial;
    background-position-y: initial;
    background-repeat: initial;
    background-attachment: initial;
    background-origin: initial;
    background-clip: initial;
    background-color: transparent;
    /*color: rgb(130, 214, 22);*/
    border-radius: 50%;
    width: 1.5875rem;
    min-width: 1.5875rem;
    height: 1.5875rem;
    min-height: 1.5875rem;
    padding: 0;
    background-size: 150% !important;
    background-position-x: 25% !important;
}

.paypal-icon {
    color: #003087;
    font-size: 2rem;
}

.credit-card-icons {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.visa-icon {
    color: #1A1F71;
    font-size: 2rem;
}

.mastercard-icon {
    font-size: 2rem;
    background: linear-gradient(90deg, #EB001B 0%, #F79E1B 100%);
    /*-webkit-background-clip: text;*/
    /*-webkit-text-fill-color: transparent;*/
}

.badge-success {
    color: rgb(17.4935064935, 162.5064935065, 70.8725201179);
    background-color: rgb(156.2441558442, 237.9558441558, 186.3220779221);
}

.badge-pending{
    color: rgb(79.2765957447, 79.2765957447, 104.7234042553);
    background-color: rgb(196.9591489362, 196.9591489362, 201.2408510638);
}

.badge-failed {
    color: rgb(255, 69, 58);
    background-color: rgb(255, 228, 225);
}

.badge-refunded {
    color: rgb(255, 165, 0);
    background-color: rgb(255, 240, 204);
}

.badge-sm {
    padding: .45em .775em;
    font-size: .65em;
    border-radius: .25rem;
}

.badge {
    text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/mainComponents/payment/assets/styles/paymentListStyleSheet.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,wCAAwC;IACxC,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,iDAAiD;IACjD,yBAAyB;IACzB,uCAAuC;IACvC,oBAAoB;IAEpB,uBAAuB;IAEvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;IAC9B,0BAA0B;IAC1B,8BAA8B;IAC9B,0BAA0B;IAC1B,wBAAwB;IACxB,6BAA6B;IAC7B,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,UAAU;IACV,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,4DAA4D;IAC5D,iCAAiC;IACjC,wCAAwC;AAC5C;;AAEA;IACI,wDAAwD;IACxD,qEAAqE;AACzE;;AAEA;IACI,wDAAwD;IACxD,qEAAqE;AACzE;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".status-icon-style {\n    position: relative;\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: transparent;\n    outline: 0px;\n    margin: 0px;\n    cursor: pointer;\n    vertical-align: middle;\n    appearance: none;\n    text-decoration: none;\n    font-family: Roboto, Helvetica, Arial, sans-serif;\n    letter-spacing: 0.02857em;\n    /*border: 1px solid rgb(130, 214, 22);*/\n    display: inline-flex;\n    -webkit-box-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    align-items: center;\n    font-weight: 700;\n    line-height: 1.4;\n    text-align: center;\n    text-transform: uppercase;\n    user-select: none;\n    transition: 150ms ease-in;\n    font-size: 0.75rem;\n    background-image: initial;\n    background-position-y: initial;\n    background-repeat: initial;\n    background-attachment: initial;\n    background-origin: initial;\n    background-clip: initial;\n    background-color: transparent;\n    /*color: rgb(130, 214, 22);*/\n    border-radius: 50%;\n    width: 1.5875rem;\n    min-width: 1.5875rem;\n    height: 1.5875rem;\n    min-height: 1.5875rem;\n    padding: 0;\n    background-size: 150% !important;\n    background-position-x: 25% !important;\n}\n\n.paypal-icon {\n    color: #003087;\n    font-size: 2rem;\n}\n\n.credit-card-icons {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n}\n\n.visa-icon {\n    color: #1A1F71;\n    font-size: 2rem;\n}\n\n.mastercard-icon {\n    font-size: 2rem;\n    background: linear-gradient(90deg, #EB001B 0%, #F79E1B 100%);\n    /*-webkit-background-clip: text;*/\n    /*-webkit-text-fill-color: transparent;*/\n}\n\n.badge-success {\n    color: rgb(17.4935064935, 162.5064935065, 70.8725201179);\n    background-color: rgb(156.2441558442, 237.9558441558, 186.3220779221);\n}\n\n.badge-pending{\n    color: rgb(79.2765957447, 79.2765957447, 104.7234042553);\n    background-color: rgb(196.9591489362, 196.9591489362, 201.2408510638);\n}\n\n.badge-failed {\n    color: rgb(255, 69, 58);\n    background-color: rgb(255, 228, 225);\n}\n\n.badge-refunded {\n    color: rgb(255, 165, 0);\n    background-color: rgb(255, 240, 204);\n}\n\n.badge-sm {\n    padding: .45em .775em;\n    font-size: .65em;\n    border-radius: .25rem;\n}\n\n.badge {\n    text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
